import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AlertServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
    };

    /**
     * alert
     * alert 리스트 조회
     * Mothod : Get
     * API No : 3.01
     * /api/v1/{cmpnNo}/alert?startDt={startDt}&endDt={endDt}&searchWord={searchWord}&statuses={status}&severities={severity}&svcNos={svcNo}&page={page}&rows={rows}&oidx={oidx}
     * **/
    getAlertList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/alert${queryString}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * alert
     * alert 상세 조회
     * Mothod : Get
     * API No : 3.02
     * /api/v1/{cmpnNo}/alert/{alrtNo}
     * **/
    getAlert(alrtNo: number) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/alert/${alrtNo}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * alert
     * Update Name
     * Mothod : Put
     * API No : 3.0.3
     * /api/v1/{cmpnNo}/alert/{alrtNo}/name
     **/
    updateName(putData: any, alrtNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/alert/${alrtNo}/name`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * alert
     * Update Description
     * Mothod : Put
     * API No : 3.0.4
     * /api/v1/{cmpnNo}/alert/{alrtNo}/desc
     **/
    updateDescription(putData: any, alrtNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/alert/${alrtNo}/desc`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/alert.services.ts